import { useEffect } from 'react'

export const usePasswordChangeRedirect = (signOutRedirectCallback: () => void) => {
	useEffect(() => {
		const isLogoutRedirect = window.location.search.includes('pwd_updated=true')
		if (isLogoutRedirect) {
			signOutRedirectCallback()
		}
	}, [signOutRedirectCallback])
}
